import React, { useState, useEffect, useContext } from "react";
import Gender from "./components/Gender";
import ProgressBar from "./components/ProgressBar";
import Birthday from "./components/Birthday";
import Name from "./components/Name";
import Email from "./components/Email";
import Password from "./components/Password";
import Result from "./components/Result";
import { ContextProfileUser } from "./lib/profileContext";
import { sendScreenResolution, simplyClick, getTTI } from "./helpers";
import { events, landingId } from "./constants";
import { useSessionData } from "ui-components";

function App() {
  const [step, setStep] = useState(1);
  const { data, setData } = useContext(ContextProfileUser);
  const { getSessionData, saveSessionData } = useSessionData(landingId);

  useEffect(() => {
    const saved = getSessionData();
    if (saved) {
      setData(saved);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      saveSessionData(data);
    }
  }, [data, saveSessionData]);

  useEffect(() => {
    const timer = setTimeout(() => {
      getTTI();
      sendScreenResolution();
    }, 5000);

    const element = document.getElementById("translation-checkpoint");
    if (!element) return;

    const initText = element.textContent?.trim() ?? "";
    let previousText = initText;

    const observer = new MutationObserver(() => {
      const currentText = element.textContent?.trim() ?? "";
      if (currentText !== previousText && initText !== currentText) {
        simplyClick("translation_detected", {
          element: "link_disclosures",
          text: currentText.slice(0, 1000),
        });
        previousText = currentText;
      }
    });

    observer.observe(element, {
      childList: true,
      characterData: true,
      subtree: true,
    });


    return () => {
      observer.disconnect();
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    const loginButton = document.querySelector(".login");

    const clickHandler = () => {
      simplyClick(events[step], null, false);
    };

    loginButton.addEventListener("click", clickHandler);

    return () => {
      loginButton.removeEventListener("click", clickHandler);
    };
  }, [step]);

  useEffect(() => {
    const signInButton = document.querySelector(".login");
    const search = window.location.search;
    const lndId =
      search === ""
        ? `?landing_id=${landingId}`
        : `${search}&landing_id=${landingId}`;

    if (signInButton) {
      signInButton?.setAttribute("href", `/login${lndId}`);
    }

    const termsLinks = document.querySelectorAll(".terms__wrap a");
    termsLinks.forEach((link) => {
      const href = link.getAttribute("href");
      if (href && !href.startsWith("mailto:")) {
        link.setAttribute("href", `${href}${lndId}`);
      }
    });
  }, []);

  const renderContent = () => {
    switch (step) {
      case 1:
        return <Gender setStep={setStep} step={step} />;
      case 2:
        return <Birthday setStep={setStep} step={step} />;
      case 3:
        return <Name setStep={setStep} step={step} />;
      case 4:
        return <Email setStep={setStep} step={step} />;
      case 5:
        return <Password setStep={setStep} step={step} />;
      case 6:
        return <Result />;
      default:
        return null;
    }
  };

  return (
    <>
      <ProgressBar step={step} />
      {renderContent()}
    </>
  );
}

export default App;
